import { API_BASE_URL } from '../globals';
import { GET_SIGNED_URL } from './routes';
import { POST } from './apiHandler';

export const getSignedUrlApi = async (url) => {
  return POST(`${API_BASE_URL}${GET_SIGNED_URL}`, { objectUrl: url });
};

export const getPdfProxyStreamApi = async (url) => {
  return POST('/crm/serverinternal/media-proxy/pdf', { url }, undefined, true);
};
